import axios from 'axios';
import BASEURL from '../utils/config';
import { authUrl } from '../utils/auth-header';

const baseURL = `${BASEURL}/AdminConfigs`;
const usersBaseURL = `${BASEURL}/users`;

const getFirstAdminConfig = async () => {
  try {
    const result = await axios.get(`${baseURL}${authUrl()}`, {});
    const adminConfigs = result.data;
    return adminConfigs[0];
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return null;
  }
};

const patchAdminConfig = async (id, data = {}) => {
  try {
    await axios.patch(`${baseURL}/${id}${authUrl()}`, data);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

const searchUsers = async (searchQuery = '') => {
  try {
    const filter = {
      where: {
        or: [
          { email: { like: `%${searchQuery}%`, options: 'i' } },
          { username: { like: `%${searchQuery}%`, options: 'i' } },
        ],
      },
      limit: 20,
      fields: ['id', 'email', 'username', 'name'],
      include: [
        {
          relation: 'therapist',
          scope: {
            fields: ['id', 'organizationId', 'userId', 'firstname', 'lastname'],
          },
        },
      ],
    };
    const filterString = `filter=${encodeURIComponent(JSON.stringify(filter))}`;
    const result = await axios.get(
      `${usersBaseURL}${authUrl()}&${filterString}`,
    );
    return result.data;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return [];
  }
};

const loginAsUser = async (userId) => {
  try {
    const result = await axios.post(
      `${usersBaseURL}/${userId}/login-as-user${authUrl()}`,
    );
    return result.data;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    throw e;
  }
};

export const adminService = {
  getFirstAdminConfig,
  patchAdminConfig,
  searchUsers,
  loginAsUser,
};
